<template>
  <div class="desktop-header d-none d-xl-block" id="desktop-header">
    <div class="container position-relative">
      <div class="d-flex justify-content-between mb-2">
        <a href="/" class="desktop-header__logo-link">
          <img src="/images/village-guide-white-logo.png" alt="Village Guide" loading="lazy">
        </a>
        <div class="d-flex align-items-center justify-content-end">
          <a
            v-if="isUserLoggedIn"
            href="#"
            :class="{ 'desktop_menu-logged-user--active': showLoginInfo }"
            class="desktop_menu-logged-user"
            @mouseover.prevent="showLoggedUserInfo">
            <i class="icon-profile"></i>
            <span class="sr-only">User profile</span>
          </a>
          <a
            v-if="!isUserLoggedIn"
            href="#"
            class="desktop_menu-login"
            @mouseover="hideMenu"
            @click.prevent="globalStore.setModal({showFooter: true, name: 'loginButtonModal'})"
          >Login</a>

          <button
            href="#"
            class="desktop_menu-search" :class="{ 'desktop_menu-search--active': showDesktopSearch }"
            @mouseover.prevent="toggleDesktopSearch()"
          >
            <i class="icon icon--search"></i>
            <span class="sr-only">Search</span>
          </button>
        </div>
      </div>

      <div class="d-flex justify-content-between align-items-baseline mb-2">
        <div
          class="desktop-header__menu"
          :class="{ 'desktop-header__menu--page': isHomePage }"
          @mouseleave="hideMenu"
        >
          <div class="desktop-header__right">
            <a
              v-for="item in mainMenuList"
              :key="item.title"
              :href="item.url"
              class="desktop_menu-link"
              :class="[desktopMenu === item.manuName ?  'desktop_menu-link--active' : '', item.manuName === 'Events' ? 'desktop_menu-link--no-dd' : '']"
              @mouseenter.prevent="toggleDesktopMenu(item.manuName)"
            >{{ item.title }}</a>
          </div>

          <transition name="fade">
            <div>
              <div
                class="menu"
                :class="`menu--${desktopMenu.toLowerCase()}`"
                v-cloak
                v-if="desktopMenu"
                ref="headerMenu"
              >
                <RetirementVillageMenu v-if="desktopMenu === 'Village'" :regions="regions" />
                <HomeForSaleMenu v-if="desktopMenu === 'HFS'" :regions="regions" :typesOfHomes="typesOfHomes" />
                <RestHomeMenu v-if="desktopMenu === 'RestHome'" :regions="regions" />
                <RetirementLivingMenu v-if="desktopMenu === 'LivingOptions'" />
                <ResourceCentreMenu v-if="desktopMenu === 'Resource'" />
              </div>

              <div v-cloak v-if="showLoginInfo">
                <div class="menu menu--account">
                  <div class="d-flex">
                    <div class="menu__item menu__item--column800">
                      <div class="menu__title">Recently saved</div>
                      <div class="menu__favourite-list">
                        <div class="menu__favourite-item" v-for="favorite in favourites">
                          <a :href="favorite.link" class="menu__favourite-link">
                            <img :src="favorite.image" :alt="favorite.title">
                            <span v-html="favorite.title"></span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="menu__item menu__item--column300">
                      <div class="menu__title">My Account</div>
                      <ul class="menu__list-type1">
                        <li v-for="link in myAccountLinks">
                          <a class="menu__link-type1" :href="link.url">{{ link.value }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <transition name="fade">
            <div class="search" v-cloak v-if="showDesktopSearch">
              <form action="/search" method="GET" class="search__form">
                <input type="text" placeholder="Search for ..." name="keyword" class="search__input">
                <i class="icon icon--search"></i>
                <button type="submit" class="search__button">Search</button>
              </form>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import useGlobalStore from './../../store/globalStore'
import RetirementVillageMenu from './RetirementVillageMenu.vue'
import HomeForSaleMenu from './HomeForSaleMenu.vue'
import RestHomeMenu from './RestHomeMenu.vue'
import EventsMenu from './EventsMenu.vue'
import RetirementLivingMenu from './RetirementLivingMenu.vue'
import ResourceCentreMenu from './ResourceCentreMenu.vue'

const props = defineProps({
  isUserLoggedIn: Boolean,
  isHomePage: Boolean,
  favourites: Array,
  regions: Array,
  typesOfHomes: Array,
})
const globalStore = useGlobalStore()
let desktopMenu = ref('')
let showDesktopSearch = ref(false)
let showLoginInfo = ref(false)
const headerMenu = ref(null)

const toggleDesktopMenu = async (menu) => {
  showDesktopSearch.value = false
  showLoginInfo.value = false
  desktopMenu.value = menu
  await nextTick()

  if (menu === 'Village') {
    headerMenu.value.style.width = '680px';
    headerMenu.value.style.left = '0px';
  } else if (menu === 'HFS') {
    headerMenu.value.style.width = '680px';
    headerMenu.value.style.left = '237px';
  } else if (menu === 'RestHome') {
    headerMenu.value.style.width = '680px';
    headerMenu.value.style.left = '400px';
  } else if (menu === 'Events') {
    // headerMenu.value.style.width = '830px';
    // headerMenu.value.style.left = '270px';
    desktopMenu.value = ''
  } else if (menu === 'LivingOptions') {
    headerMenu.value.style.width = '670px';
    headerMenu.value.style.left = '247px';
  } else if (menu === 'Resource') {
    headerMenu.value.style.width = '350px';
    headerMenu.value.style.left = '742px';
  }
};

const toggleDesktopSearch = () => {
  desktopMenu.value = ''
  showLoginInfo.value = false
  showDesktopSearch.value = true
};

const hideMenu = () => {
  showDesktopSearch.value = false
  desktopMenu.value = ''
  showLoginInfo.value = false
};

const showLoggedUserInfo = () => {
  desktopMenu.value = ''
  showDesktopSearch.value = false
  showLoginInfo.value = true
};

const mainMenuList = [
  { title: 'Find a retirement village', url: '/retirement-villages', manuName: 'Village' },
  { title: 'Homes for sale', url: '/available-properties', manuName: 'HFS' },
  { title: 'Find a rest home', url: '/rest-homes', manuName: 'RestHome' },
  { title: 'Open days & events', url: '/retirement-villages/open-days', manuName: 'Events' },
  { title: 'Living options', url: '#', manuName: 'LivingOptions' },
  { title: 'Resource centre', url: '/resource-centre/retirement-villages', manuName: 'Resource' },
];

const myAccountLinks = {
  mySavedList: {
    url: '/my-saved-list',
    value: 'My Saved List',
  },
  emailPreferences: {
    url: '/email-preferences',
    value: 'Email Preferences',
  },
  profile: {
    url: '/profile',
    value: 'Profile',
  },
  passwordChange: {
    url: '/password-change',
    value: 'Password',
  },
  logout: {
    url: '/logout',
    value: 'Logout',
  },
};

</script>
